// extracted by mini-css-extract-plugin
module.exports = {"spacer":"V_dJ","title-container":"V_dK","titleContainer":"V_dK","title":"V_bx"};